/* eslint-disable @typescript-eslint/no-explicit-any */

import { FormikProvider, useFormik } from 'formik'
import * as yup from 'yup'
import { Container, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import Dialog from 'components/dialog/dialog'
import type { DetailStateProps, ErrorProps } from 'modules/types'
import type { PartialUpdateAccountStatusProps } from 'modules/partial'
import { useUpdateAppointmentConfirmationMutation } from 'store/serviceBookingEventTransaction'
import Notification from 'components/notification'
import GLOBAL from 'modules/global'
import DialogStyle from './arrivalConfirmationStyle'

const ArrivalConfirmation = ({
  open,
  id,
  vin,
  vehicleId,
  accountStatus,
  onClose
}: DetailStateProps & {
  id: number
  vin: string
  vehicleId: number
  accountStatus: string
}) => {
  if (!open) return <></>

  const [updateAppointmentConfirmation, update] = useUpdateAppointmentConfirmationMutation()
  const scheme = yup.object<PartialUpdateAccountStatusProps>({
    Status: yup.string().required('Account Status is required')
  })

  const formik = useFormik<PartialUpdateAccountStatusProps>({
    validationSchema: scheme,
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: {
      RegistrationCode: id,
      Vin: vin,
      VehicleId: vehicleId,
      Status: accountStatus
    },
    onSubmit: (values: PartialUpdateAccountStatusProps) => handleSubmit(values)
  })

  const handleSubmit = (e: PartialUpdateAccountStatusProps) => {
    const payload: any = {
      id: id,
      appointmentConfirmation: e.Status,
    }

    updateAppointmentConfirmation(payload)
  }

  return (
    <>
      <Dialog
        open={open}
        title='Arrival Confirmation'
        onCancel={onClose}
        onSubmit={() => formik.handleSubmit()}
        loading={false}
        isDisabled={!formik.isValid}
        submitText='Update'
        cancelText='Cancel'
      >
        <Container {...DialogStyle.Container}>
          {id && (
            <>
              <FormikProvider value={formik}>
                <FormControl fullWidth>
                  <InputLabel id='Status'>Account Status</InputLabel>
                  <Select
                    labelId='Status'
                    id='Status'
                    value={formik.values.Status}
                    label='Account Status'
                    onChange={(event) => formik.setFieldValue('Status', event.target.value)}
                  >
                    <MenuItem value='Confirmed'>Confirmed</MenuItem>
                    <MenuItem value='Canceled'>Canceled</MenuItem>
                  </Select>
                </FormControl>
              </FormikProvider>
            </>
          )}
        </Container>
      </Dialog>

      <Notification
        open={!update.isLoading && !update.isUninitialized}
        onClose={() => (update.isError ? update.reset() : location.reload())}
        isError={update.isError}
        message={GLOBAL.returnExceptionMessage(update.isError, update.error as ErrorProps)}
      />
    </>
  )
}

export default ArrivalConfirmation
